// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ds-badge{display:inline-block;padding:2px 4px;margin-left:3px;margin-right:3px;border-radius:4px;font-size:11px;line-height:13px;padding:2px 4px;background-color:var(--gray-2);color:var(--gray-5)}.ds-badge.primary{background-color:var(--primary-color);color:#fff}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
